import { bomItemSelector } from 'features/BillOfMaterials/store/selectors/bomItemSelector'
import { BomItemPointer } from 'model/Project/BomItemPointer'
import { BomItemType } from 'model/Project/BoMItemRow'
import { RootAppState } from 'store/configureStore'

export const bomItemScaleSelector =
  (bomItemPointer: BomItemPointer) => (state: RootAppState) => {
    const bomItem = bomItemSelector(state, bomItemPointer)

    switch (bomItem?.type) {
      case BomItemType.assemblyType:
      case BomItemType.assemblyInstance: {
        if (bomItem.representsIndividualParts) {
          return null
        } else {
          return bomItem.animalScale
        }
      }
      case BomItemType.partInstance:
      case BomItemType.partType:
        return bomItem.animalScale
      default:
        return undefined
    }
  }
